// asyncStorage.ts
import localForage from "localforage";

const asyncStorage = {
  getItem: <T>(key: string): Promise<T | null> => localForage.getItem<T>(key),
  setItem: <T>(key: string, value: T): Promise<T> =>
    localForage.setItem<T>(key, value),
  removeItem: (key: string): Promise<void> => localForage.removeItem(key),
};

export default asyncStorage;
